import React from "react";
import { Button, Form, Input, Select } from "antd";
import { createPlaywrightForm } from "../createPlaywrightForm";
const { TextArea } = Input;

const FormClosingReason = ({ onSubmit, closingReasons, form }) => {
	const { getFieldDecorator } = form;

  return (
    <Form layout="vertical" onSubmit={(e) => onSubmit(e, form)}>
      <Form.Item
        label={"Indica el motivo de cierre del proceso"}
      >
        {getFieldDecorator("closing_reason_id", {
          rules: [
            {
              message: "Es necesario seleccionar el motivo de cierre",
              required: true
            },
          ]
        })(
          <Select placeholder="Seleccione el motivo">
            {closingReasons.map((item, key) => (
              <Select.Option key={key} value={item.id}>{item.description}</Select.Option>
            ))}
          </Select>
        )}
      </Form.Item>
      <Form.Item
        label="Comentarios adicionales"
      >
        {getFieldDecorator("closing_reason_comment")(
          <TextArea
            placeholder="Escriba un comentario adicional para el motivo de cierre"
            autoSize
          />
        )}
      </Form.Item>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          className="btn-success-modal"
        >
          Cerrar proceso
        </Button>
      </Form.Item>
    </Form>
  );
};


const createForm = typeof Form.create === "function" ? Form.create : createPlaywrightForm;
const ClosingReasonForm = createForm({ name: "edit-profile-form" })(FormClosingReason);

export default ClosingReasonForm;
